// extracted by mini-css-extract-plugin
export default {"reponsiveCont":"responsivemessage_reponsiveCont__qFV8n","textCont":"responsivemessage_textCont__0Z0Ir"};